import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { login } from '../isAuthSlice';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface ILoginPayload {
  email: string;
  password: string;
}

export const ambassadorSlice = createApi({
  reducerPath: 'ambassador',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API
  }),
  endpoints: (builder) => ({
    logIn: builder.mutation<IAnyResponse, ILoginPayload>({
      query: (payload) => ({
        url: `/auth/local`,
        method: 'POST',
        body: {
          identifier: payload.email,
          password: payload.password
        }
      })
    })
  })
});

export const { useLogInMutation } = ambassadorSlice;
